import { buildInfiniteScrollingArticlesUrl } from '../../utils/build-urls';
import { skyFoundationSettings } from '../../services/configs/configs-service';
import { isNativeLazyLoadingSupported } from '../../utils/device-utils';

const config = require('config');

const lazyLoadingClass = config.lazyLoadingContents.lazyClass;

const isGallery = (value) => value.gallery;

const hasTwoLabels = (cardData) => cardData.channelLabel || cardData.liveblog || cardData.section;

const isBlog = (cardData) => cardData.blog;

/**
 * Render no blog information
 * @param {*} cardData card model
 */
const renderNoBlog = (cardData) => {
  return `
    ${
      cardData.idVideo > 0
        ? `
    <i class="icon icon--media icon--play icon--medium icon--c-primary">
      <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"
            class="icon__svg icon__svg--play">
          <path d="M13 4.812c0-1.094.372-2.155 1.053-3.01a4.783 4.783 0 0 1 6.74-.745l43.744 35.188a4.824 4.824 0 0 1 0 7.51L20.793 78.943A4.784 4.784 0 0 1 17.795 80C15.147 80 13 77.845 13 75.188V4.812z"/>
      </svg>
    </i>`
        : ``
    }
    ${
      isGallery(cardData)
        ? `
          <i class="icon icon--media icon--gallery icon--medium icon--c-primary">
              <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg"
                   class="icon__svg icon__svg--gallery">
                  <path d="M17.005 20.221h60.211c1.538 0 2.784 1.28 2.784 2.858v48.317c0 1.578-1.246 2.858-2.784 2.858H17.005c-1.537 0-2.784-1.28-2.784-2.858V23.079c0-1.578 1.247-2.858 2.784-2.858zM5.873 11.873V60.62a2.937 2.937 0 0 1-5.873 0V11.286A5.286 5.286 0 0 1 5.286 6h61.08a2.937 2.937 0 1 1 0 5.873H5.873z"></path>
              </svg>
          </i>`
        : ``
    }
  `;
};

/**
 * render author information for blog
 * @param {*} cardData card model
 */
const renderAuthor = (cardData) => {
  if (isBlog(cardData) && cardData.author !== null) {
    return `
      <div class="c-card__author">
        ${
          cardData.author.image !== null
            ? `
          <div class="c-card__author-img-wrapper">
              <div class="o-image-circle o-aspect-ratio o-aspect-ratio--square">
                  <img crossorigin="anonymous" class="o-image-circle__img"
                       alt="${cardData.author.name}"
                       src="${cardData.author.image}" sizes="5vw"
                       srcset="${cardData.author.image} 74w, ${cardData.author.image} 148w"/>
              </div>
          </div>`
            : ''
        }
      ${
        cardData.author.name !== null
          ? `
              <div class="c-card__author-info">
                ${cardData.blogLabel ? `<span class="c-card__intro-label">${cardData.blogLabel}</span>` : ''}
                <p class="${cardData.blogLabel ? 'c-card__author-name' : 'c-card__author-name-no-intro'}">${
                  cardData.author.name
                }</p>
              </div>`
          : ''
      }
    </div>`;
  }
  return ``;
};

/**
 * author without image
 * @param {*} cardData card model
 */
const blogAuthorNoImage = (cardData) => isBlog(cardData) && cardData.author && !cardData.author.image;

/**
 * Render labels
 * @param {*} cardData card model
 */
const renderLabel = (cardData) => {
  const labelClass = cardData.premium
    ? 'c-label c-label--article-heading c-label--editorial-premium'
    : 'c-label c-label--article-heading';
  if (hasTwoLabels(cardData) && !isBlog(cardData)) {
    return `
        <div class="c-card__label-wrapper c-label-wrapper">
          ${cardData.liveblog && cardData.liveblogOpen ? '<span class="c-label c-label--live">live</span>' : ''}
          ${cardData.hasLabel ? `<span class="${labelClass}">${cardData.label}</span>` : ''}
          ${
            cardData.channelLabel
              ? `<span class="c-label c-label--article-heading-light"> ${cardData.channelLabel} </span>`
              : ''
          }
        </div>`;
  } else if (cardData.hasLabel && !isBlog(cardData)) {
    return `
          ${cardData.liveblog && cardData.liveblogOpen ? '<span class="c-label c-label--live">live</span>' : ''}
          ${cardData.hasLabel ? `<span class="${labelClass}">${cardData.label}</span>` : ''}
          ${
            cardData.channelLabel
              ? `<span class="c-label c-label--article-heading-light">${cardData.channelLabel}</span>`
              : ''
          }
    `;
  }
  return ``;
};

/**
 * render Date
 * @param {*} cardData card model
 */
const renderDate = (cardData) => {
  if (cardData.date !== '') {
    if (isGallery(cardData)) {
      return `
    <div class="c-card__info">
        <time class="c-card__date" datetime="${cardData.date}">${cardData.date}
        </time>
        <span class="c-card__content-data">
            <i class="icon icon--media-outline icon--gallery-outline icon--xxsmall icon--c-neutral">
                <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--gallery-outline"><path d="M26.174 32.174v31.975h44.588V32.174H26.174zm-3.08-9.238h50.747A6.159 6.159 0 0 1 80 29.095v38.134a6.159 6.159 0 0 1-6.159 6.158H23.095a6.159 6.159 0 0 1-6.159-6.158V29.095a6.159 6.159 0 0 1 6.159-6.159zM9.239 55.665a4.619 4.619 0 0 1-9.238 0V16.777C0 10.825 4.825 6 10.777 6H64.08a4.619 4.619 0 1 1 0 9.238H10.777c-.85 0-1.54.69-1.54 1.54v38.887z" fill="currentColor" fill-rule="evenodd"></path></svg>
            </i>
            ${cardData.imagesNumber} foto
        </span>
    </div>`;
    } else if (!isGallery(cardData) && !isBlog(cardData)) {
      return `
      <time class="c-card__date" datetime="${cardData.date}">${cardData.date}</time>
    `;
    }
  }
  return ``;
};

const getImageTemplate = (cardData, placeholder, alt) => {
  if (isNativeLazyLoadingSupported()) {
    return `<img crossorigin="anonymous" class="c-card__img ${lazyLoadingClass}" ${alt !== '' ? `alt="${alt}"` : ''}
    srcset="${cardData.renditions['card-desktop']} 314w,
    ${cardData.renditions['card-desktop-2x']} 628w,
    ${cardData.renditions['card-tablet']} 416w,
    ${cardData.renditions['card-tablet-2x']} 832w,
    ${cardData.renditions['card-mobile']}  375w,
    ${cardData.renditions['card-mobile-2x']}  750w" sizes="(max-width: 1024px) 100vw,
    30vw"
    loading="lazy"
    src="${cardData.renditions['card-tablet']}">`;
  }
  return `<img crossorigin="anonymous" class="c-card__img ${lazyLoadingClass}" ${alt !== '' ? `alt="${alt}"` : ''}
    data-srcset="${cardData.renditions['card-desktop']} 314w,
    ${cardData.renditions['card-desktop-2x']} 628w,
    ${cardData.renditions['card-tablet']} 416w,
    ${cardData.renditions['card-tablet-2x']} 832w,
    ${cardData.renditions['card-mobile']}  375w,
    ${cardData.renditions['card-mobile-2x']}  750w" sizes="(max-width: 1024px) 100vw,
    30vw"
    src="${placeholder}"
    data-src="${cardData.renditions['card-tablet']}">`;
};

/**
 * Render card image
 * @param {*} cardData card model
 * @param {*} placeholder the image placeholder
 * @param {*} alt
 */
const renderCardImage = (cardData, placeholder, alt) => {
  return `${
    cardData.hasImage && cardData.hasRenditions
      ? `
    <div class="c-card__img-wrapper">
          <figure class="o-aspect-ratio o-aspect-ratio--16-10 ">
           ${getImageTemplate(cardData, placeholder, alt)}
            <noscript>
              <img crossorigin="anonymous" class="c-card__img" ${alt !== '' ? `alt="${alt}"` : ''}
                srcset="${cardData.renditions['card-desktop']} 314w,
                ${cardData.renditions['card-desktop-2x']} 628w,
                ${cardData.renditions['card-tablet']} 416w,
                ${cardData.renditions['card-tablet-2x']} 832w,
                ${cardData.renditions['card-mobile']}  375w,
                ${cardData.renditions['card-mobile-2x']}  750w" sizes="(max-width: 1024px) 100vw,
                30vw"
                src="${cardData.renditions['card-tablet']}">
            </noscript>
          </figure>
        ${!isBlog(cardData) ? renderNoBlog(cardData) : ``}
    </div>`
      : ``
  }
          `;
};

/**
 * Render abstract if is not blog item
 * @param {*} cardData
 */
const renderAbstract = (cardData) =>
  !isBlog(cardData) && cardData.abstract !== '' ? `<p class="c-card__abstract">${cardData.abstract}</p>` : '';

/**
 * Render card title
 * @param {*} title card title
 */
const renderCardTitle = (title) => `<h2 class="c-card__title">${title}</h2>`;

/**
 * Render sponsored artitle label
 * @param {*} cardData
 */
const renderSponsoredArticle = (cardData) => {
  const labelClass = cardData.premium
    ? 'c-label c-label--article-sponsored c-label--editorial-premium'
    : 'c-label c-label--article-sponsored';
  if (!isBlog(cardData) && cardData.sponsored) {
    return `<span class="${labelClass}">sponsorizzato</span>`;
  }
  return ``;
};

/**
 * Build infinite card template
 * @param {*} value
 * @param {*} constainerClasses
 * @param {*} cardClasses
 * @param {*} pagination
 */
export const infiniteCardTemplate = (value, constainerClasses, cardClasses, pagination) => {
  const cardData = { ...value };
  cardData.title = value.title ? value.title : '';
  cardData.url = value.url ? buildInfiniteScrollingArticlesUrl(value.url) : '';
  cardData.label = value.section.label ? value.section.label : '';
  cardData.hasLabel = Boolean(value.section.label);
  cardData.abstract = value.abstractText ? value.abstractText : '';
  cardData.date = value.date ? value.date : '';
  cardData.alt = value.image !== null && value.image.alt !== undefined ? value.image.alt : '';
  cardData.hasImage = value.image !== null && value.image.src;
  cardData.renditions = value.image !== null && value.image.src !== null ? value.image.renditionsMapSrc : {};
  cardData.hasRenditions = cardData.renditions !== undefined;
  cardData.blogLabel = cardData.cardBlogLabel || '';
  const placeholder = skyFoundationSettings.getStaticDomain() + config.placeholder.path;

  return `<div class="${constainerClasses} ${pagination.isFirst || pagination.isLast ? `j-page-counter` : ``}" ${
    pagination.isFirst || pagination.isLast
      ? `id=j-page-counter-${pagination.counter} data-page=${pagination.counter}`
      : ``
  }>
    <a class="${cardClasses} ${cardData.hasImage ? '' : ' c-card--no-image'} ${
      !isBlog(cardData) && (isGallery(cardData) || cardData.idVideo > 0) ? ' c-card--media' : ''
    } ${blogAuthorNoImage(cardData) ? ' c-card--no-author-image' : ''}" href="${cardData.url}">
    <article class="c-card__wrapper">
      <div class="c-card__content">
        ${renderCardTitle(cardData.title)}
        ${renderAuthor(cardData)}
        ${renderLabel(cardData)}
        ${renderAbstract(cardData)}
        ${renderDate(cardData)}
        ${renderSponsoredArticle(cardData)}
      </div>
      ${renderCardImage(cardData, placeholder, cardData.alt)}
    </article>
    </a>
    </div>`;
};

export const loaderTemplate = () => {
  return `
  <div class="c-loader c-loader--medium" id="infinite-loader">
    <div class="c-loader__item"></div>
    <div class="c-loader__item"></div>
    <div class="c-loader__item"></div>
  </div>`;
};
